export const CHECKIN_QUESTIONS = {
  morning: [
    { questionId: 'sleep_hours', questionText: 'How many hours did you sleep?', type: 'sleep', answerType: 'scale', min: 0, max: 12 },
    { questionId: 'rested', questionText: 'How rested do you feel?', type: 'sleep', answerType: 'scale', min: 1, max: 5 },
    { questionId: 'morning_mood', questionText: 'How are you feeling this morning?', type: 'mood', answerType: 'select', options: ['😞', '😕', '😐', '🙂', '😄'] },
  ],
  midday: [
    { questionId: 'midday_stress', questionText: 'How stressed do you feel right now?', type: 'stress', answerType: 'scale', min: 1, max: 5 },
    { questionId: 'midday_energy', questionText: 'What is your energy level?', type: 'energy', answerType: 'scale', min: 1, max: 5 },
    { questionId: 'moved_today', questionText: 'Have you moved your body today?', type: 'physical', answerType: 'boolean' },
  ],
  evening: [
    { questionId: 'evening_mood', questionText: 'How do you feel about the day overall?', type: 'mood', answerType: 'scale', min: 1, max: 5 },
    { questionId: 'connected', questionText: 'Did you connect meaningfully with anyone today?', type: 'social', answerType: 'boolean' },
    { questionId: 'grateful_for', questionText: 'What are you grateful for today?', type: 'reflection', answerType: 'text' },
  ],
};

export const getCurrentTimeSlot = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'morning';
  if (hour < 17) return 'midday';
  return 'evening';
};